import { Component, EventEmitter, Input, Output, Optional, Host } from '@angular/core';
import { C4InputInterface, C4Input, C4InputConfig } from '../c4-input';
import { C4Form } from '../c4-form';

@Component({
  selector: 'c4-input-color',
  templateUrl: 'c4-input-color.html',
  styles: [`
		.control-label {
			font-weight: normal;
		}
	`],
})
export class C4InputColor extends C4Input implements C4InputInterface {
  @Input() config;
  @Input() name: string;
  @Input() tagId: string;
  @Input() value: string;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  constructor( @Optional() @Host() form: C4Form) {
    super(form);
  }

}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/color/c4-input-color.ts